module.exports = __webpack_public_path__ + "img/w53.1a4141eb.svg";